export const MOBILE_FILTER_BUTTON_PADDING = 10
export const TECHNIQUE_BUTTON_CONTAINER_HEIGHT = 36
